import { Apps20Regular, CloudArrowUp20Regular, Globe20Regular, Key20Regular } from "@fluentui/react-icons";

export interface QuickTask {
    id: string;
    title: string;
    description: string;
    icon: React.ReactNode;
}

export const quickTasks: QuickTask[] = [
    {
        id: "azure-subscription",
        title: "Azure subscription",
        description: "How can I request an Azure subscription?",
        icon: <CloudArrowUp20Regular />,
    },
    {
        id: "aws-access",
        title: "AWS access",
        description: "How do I get access to AWS?",
        icon: <Key20Regular />,
    },
    {
        id: "private-dns",
        title: "Private DNS",
        description: "Is private DNS supported on the Azure ECN connected subscriptions?",
        icon: <Globe20Regular />,
    },
    {
        id: "internal-app",
        title: "Internal app hosting",
        description: "Which service should I use for an internal web app?",
        icon: <Apps20Regular />,
    },
];

export interface HomeInputProps {
    onInputSubmit: (input: string) => void;
    onQuickTaskSelect: (taskDescription: string) => void;
}
